module.exports = __webpack_public_path__ + "static/img/MD.7bb1ffde.svg";